import React from 'react'
import Index from './Index'

interface Props {}

const Products: React.FC<Props> = () => {
  return <Index />
}

export default Products
